import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GalaxyDatepickerModule } from '@vendasta/galaxy/datepicker';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { KeywordTrackingModule, KeywordTrackingService, UpgradeCTADialogService } from '@vendasta/local-seo';
import { DateRangeSelectorModule, UIKitModule } from '@vendasta/uikit';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { AuthWallModule } from '../auth-wall';
import { BrandFilterContainerModule } from '../brands/brand-filter-container/brand-filter-container.module';
import { WEBLATE_COMPONENT_NAME } from '../constants';
import { InviteUserSidebarModule } from '../my-team/invite-user-sidebar/invite-user-sidebar.component';
import { TimeRangePickerComponent } from '../shared/time-range-picker.component';
import { ConfirmCloseDialogComponent } from './confirm-close/confirm-close-dialog.component';
import { NavigationComponent } from './navigation.component';
import { LaunchAppButtonComponent } from '../launch-app-button/launch-app-button.component';
import { ActionButtonComponent } from './action-button/action-button.component';

@NgModule({
  declarations: [NavigationComponent, ConfirmCloseDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    UIKitModule,
    MatToolbarModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatListModule,
    MatInputModule,
    MatChipsModule,
    MatMenuModule,
    MatRadioModule,
    MatSidenavModule,
    MatIconModule,
    PortalModule,
    RouterModule,
    FormsModule,
    MatRippleModule,
    AuthWallModule,
    DateRangeSelectorModule,
    MatTooltipModule,
    GalaxyPopoverModule,
    OverlayModule,
    GalaxyDatepickerModule,
    BrandFilterContainerModule,
    InviteUserSidebarModule,
    NgxChartsModule,
    KeywordTrackingModule,
    TimeRangePickerComponent,
    LaunchAppButtonComponent,
    ActionButtonComponent,
  ],
  providers: [KeywordTrackingService, UpgradeCTADialogService],
  exports: [NavigationComponent],
})
export class NavigationModule {}
